import React from "react";
import { PageHeader } from "../components/shared/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { PlansTab } from "../components/catalog/PlansTab";
import { ItemsTab } from "../components/catalog/ItemsTab";
import { AddonsTab } from "../components/catalog/AddonsTab";
import { DailyMenuTab } from "../components/catalog/DailyMenuTab";
import { useListState } from "../hooks/useListState";

export default function Catalog() {
  const [activeTab, setActiveTab] = useListState("catalog.activeTab", "plans");
  return (
    <div data-testid="catalog-page">
      <PageHeader title="Catalog" description="Subscription plans, menu items, addons and the daily menu." />
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList data-testid="catalog-tabs">
          <TabsTrigger value="plans" data-testid="catalog-tab-plans">Plans</TabsTrigger>
          <TabsTrigger value="items" data-testid="catalog-tab-items">Items</TabsTrigger>
          <TabsTrigger value="addons" data-testid="catalog-tab-addons">Addons</TabsTrigger>
          <TabsTrigger value="daily-menu" data-testid="catalog-tab-daily-menu">Daily Menu</TabsTrigger>
        </TabsList>
        <TabsContent value="plans"><PlansTab /></TabsContent>
        <TabsContent value="items"><ItemsTab /></TabsContent>
        <TabsContent value="addons"><AddonsTab /></TabsContent>
        <TabsContent value="daily-menu"><DailyMenuTab /></TabsContent>
      </Tabs>
    </div>
  );
}
